import React from 'react';

export type EmptyProps = {
  title: string;
  subtitle?: string;
  cta?: React.ReactNode;
  image?: React.ReactElement;
  children?: React.ReactNode;
  className?: string;
};

export default function Empty({
  title,
  subtitle,
  cta,
  image,
  children,
  className = '',
}: EmptyProps) {
  return (
    <div
      className={`flex flex-col items-center mt-12 v2-text-neutral-500 ${className}`}
    >
      <div className='text-4xl font-black text-center'>{title}</div>
      {subtitle && (
        <div className='text-base mt-8 max-w-[728px] text-center'>
          {subtitle}
        </div>
      )}
      {cta && <div className='mt-8 mb-12'>{cta}</div>}
      {image && <div>{image}</div>}
      {children}
    </div>
  );
}
